/**
 * @fileoverview DataCotizador
 * @version 1.0
 * @author Carlos Emilio Blanco Lopez
 * @date 14/02/2023
 * @copyright 2023 Industrias RESSER S.A de C.V
 */

import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { DataState } from '../../../interfaces/commonInterfaces';

/**
 * @title initialState
 * @description objecto inicial del Slice DataCotizador
 */


const initialState: DataState = {
    quoteType: 0, // Tipo de Cotizacion
    leasingType: 0, // Tipo de Arrendamiento
    //Credit Quotation Data
    financingType: 0, // Tipo de Financiamiento
    credit:0, // Monto del Credito
    creditFormat: 0, 
    productTypeOption: undefined,
    //Arrendamient Quotation data 
    userActivo: 17, // Tipo de Activo
    userPlazo: 12, // Plazo del activo
    assetPrice: 0, // Precio del activo// Precio del activo
    purchaseOption: "_", // Opcion de compra
    assetDownPayment: undefined, // Enganche del activo

    //Another Quotation Data
    plazo: 12,
    tasa: 0,
    payment: 0,
    ekatenaId: 0,
    folio: '',
    //Data ACreditado
    userType: 1,
    userRFC: "",
    userFirstName: "",
    userSecondName: "",
    userFirstLastName: "",
    userSecondLastName: "",
    userCellphone: "",
    userEmail: "",
    userStreet: "",
    userNumberHouse: "",
    userCP: "",
    userCodigoPostalID: undefined,
    userState: "",
    userMunicipality: "",
    userColony: "",
    userContactMethod: "0",
    userEnterprise: "",
    userNationality: "",
    userGender: "",
    genderType: undefined,
    // Data Representate Legal
    legalRepresentativeRFC: "",
    legalRepresentativeFirstName: "",
    legalRepresentativeSecondName: "",
    legalRepresentativeFirstLastName: "",
    legalRepresentativeSecondLastName: "",
    legalRepresentativeCellphone: "",
    legalRepresentativeEmail: "",
    // Data Ingresos
    revenueSpin: undefined,
    revenueFountain: undefined,
    revenuePercentage: undefined,
    revenueMonthlyAverage: undefined,
    revenueMonthlyExpense: undefined,
    revenueInitialDate: "",
    revenueCustomerConcentration: undefined,
    // Data Aval
    avalType: 0,
    avalEnterprise: "",
    avalNationality: "",
    avalCellphone: "",
    avalEmail: "",
    avalStreet: "",
    avalNumberHouse: "",
    avalCP: "",
    avalCodigoPostalID: undefined,
    avalState: "",
    avalMunicipality: "",
    avalColony: "",
    avalCity: "",
    avalRFC: "",
    avalContactMethod: "",
    avalFirstName: "",
    avalSecondName: "",
    avalFirstLastName: "",
    avalSecondLastName: "",
    avalGender:"",
    avalGenderType: undefined,
    // Data NIP
    NIP: undefined,
    UserObjColonias: [],
    AvalObjColonias: [],
    ViewEkatena: false,
    //Validates Userv
    validateUserRFC: undefined,
    validateUserEmail: undefined,
    validatelegalRepresentativeEmail: undefined,
    validateLegalRepresentativeRFC: undefined,
    validateAvalRFC: undefined,
    validateAvalEmail: undefined,
    autorizeNIP: false,
    SuccessEkatena: false,
    byEmail: true,
    actualStep: 0,
    isDisableQuoteForm: false,
    isLoadingData: false,
    unipadHash: "",
    assetDownPaymentHasError: false,

};

/**
 * @title DataCotizador
 * @description Slice de apoyo para obtencion de datos del Cotizador.
 */

export const DataCotizador = createSlice({
    name: 'dataCotizador',
    initialState,
    reducers: {
        getQuoteType: (state: DataState, action: PayloadAction<number>) => { state.quoteType = action.payload },
        //Data Leasing
        getLeasingType: (state: DataState, action: PayloadAction<number>) => { state.leasingType = action.payload },
        getUserActivo: (state: DataState, action: PayloadAction<number>) => { state.userActivo = action.payload },
        getAssetPrice: (state: DataState, action: PayloadAction<number | undefined>) => { state.assetPrice = action.payload },
        getAssetDownPayment: (state: DataState, action: PayloadAction<number>) => { state.assetDownPayment = +action.payload },
        getUserPlazo: (state: DataState, action: PayloadAction<number>) => { state.userPlazo = action.payload },
        getPurchaseOption: (state: DataState, action: PayloadAction<"ResidualEstandar" | "ResidualMaximo" | "ResidualMinimo" | "_">) => { state.purchaseOption = action.payload },
        //Data Credit
        getProductTypeOption: (state: DataState, action: PayloadAction<number | undefined>) => {state.productTypeOption = action.payload},
        getProductType: (state: DataState, action: PayloadAction<number | undefined>) => {state.productTypeOption = action.payload},
        getCredit: (state: DataState, action: PayloadAction<number>) => {state.credit = action.payload},
        getCreditFormat: (state: DataState, action: PayloadAction<number>) => {state.creditFormat = action.payload},
        //General Data
        getPlazo: (state: DataState, action: PayloadAction<number>) => { state.plazo = action.payload },
        getTasa: (state: DataState, action: PayloadAction<number | undefined>) => { state.tasa = action.payload },
        getEkatenaId: (state: DataState, action: PayloadAction<number | undefined>) => { state.ekatenaId = action.payload },
        getPayment: (state: DataState, action: PayloadAction<number | undefined>) => { state.payment = action.payload },
        getFolio: (state: DataState, action: PayloadAction<string>) => { state.folio = action.payload },
        // Data Acreditado
        getUserType: (state: DataState, action: PayloadAction<number>) => { state.userType = action.payload },
        getUserRFC: (state: DataState, action: PayloadAction<string>) => { state.userRFC = action.payload },
        getUserFirstName: (state: DataState, action: PayloadAction<string>) => { state.userFirstName = action.payload },
        getUserSecondName: (state: DataState, action: PayloadAction<string>) => { state.userSecondName = action.payload },
        getUserFirstLastName: (state: DataState, action: PayloadAction<string>) => { state.userFirstLastName = action.payload },
        getUserSecondLastName: (state: DataState, action: PayloadAction<string>) => { state.userSecondLastName = action.payload },
        getUserCellphone: (state: DataState, action: PayloadAction<string>) => { state.userCellphone = action.payload },
        getUserEmail: (state: DataState, action: PayloadAction<string>) => { state.userEmail = action.payload },
        getUserStreet: (state: DataState, action: PayloadAction<string>) => { state.userStreet = action.payload },
        getUserNumberHouse: (state: DataState, action: PayloadAction<string>) => { state.userNumberHouse = action.payload },
        getUserCP: (state: DataState, action: PayloadAction<string>) => { state.userCP = action.payload },
        getUserCodigoPostalID: (state: DataState, action: PayloadAction<number>) => { state.userCodigoPostalID = action.payload },
        getUserState: (state: DataState, action: PayloadAction<string>) => { state.userState = action.payload },
        getUserMunicipality: (state: DataState, action: PayloadAction<string>) => { state.userMunicipality = action.payload },
        getUserColony: (state: DataState, action: PayloadAction<string>) => { state.userColony = action.payload },
        getUserContactMethod: (state: DataState, action: PayloadAction<string>) => {state.userContactMethod = action.payload },
        getUserGender: (state: DataState, action: PayloadAction<string>) => {state.userGender = action.payload},        
        getGenderType: (state: DataState, action: PayloadAction<number>) => {state.genderType = action.payload},
        getUserEnterprise : (state: DataState, action: PayloadAction<string>) => { state.userEnterprise = action.payload },
        getUserNationality : (state: DataState, action: PayloadAction<string>) => { state.userNationality = action.payload },
        // Data Legal Representative
        getLegalRepresentativeRFC: (state: DataState, action: PayloadAction<string>) => { state.legalRepresentativeRFC = action.payload },
        getLegalRepresentativeFirstName: (state: DataState, action: PayloadAction<string>) => { state.legalRepresentativeFirstName = action.payload },
        getLegalRepresentativeSecondName: (state: DataState, action: PayloadAction<string>) => { state.legalRepresentativeSecondName = action.payload },
        getLegalRepresentativeFirstLastName: (state: DataState, action: PayloadAction<string>) => { state.legalRepresentativeFirstLastName = action.payload },
        getLegalRepresentativeSecondLastName: (state: DataState, action: PayloadAction<string>) => { state.legalRepresentativeSecondLastName = action.payload },
        getLegalRepresentativeCellphone: (state: DataState, action: PayloadAction<string>) => { state.legalRepresentativeCellphone = action.payload },
        getLegalRepresentativeEmail: (state: DataState, action: PayloadAction<string>) => { state.legalRepresentativeEmail = action.payload },
        getUserObjColonias: (state: DataState, action: PayloadAction<{ id: number, name: string }[]>) => { state.UserObjColonias = action.payload },
        //Data Aval
        getAvalType: (state: DataState, action: PayloadAction<number>) => { state.avalType = action.payload },
        getAvalEnterprise: (state: DataState, action: PayloadAction<string>) => { state.avalEnterprise = action.payload },
        getAvalNationatily: (state: DataState, action: PayloadAction<string>) => { state.avalNationality = action.payload },
        getAvalCellphone: (state: DataState, action: PayloadAction<string>) => { state.avalCellphone = action.payload },
        getAvalEmail: (state: DataState, action: PayloadAction<string>) => { state.avalEmail = action.payload },
        getAvalStreet: (state: DataState, action: PayloadAction<string>) => { state.avalStreet = action.payload },
        getAvalNumberHouse: (state: DataState, action: PayloadAction<string>) => { state.avalNumberHouse = action.payload  },
        getAvalCP: (state: DataState, action: PayloadAction<string>) => { state.avalCP = action.payload },
        getAvalCodigoPostalID: (state: DataState, action: PayloadAction<number>) => { state.avalCodigoPostalID = action.payload },
        getAvalState: (state: DataState, action: PayloadAction<string>) => { state.avalState = action.payload },
        getAvalMunicipality: (state: DataState, action: PayloadAction<string>) => { state.avalMunicipality = action.payload },
        getAvalColony: (state: DataState, action: PayloadAction<string>) => { state.avalColony = action.payload },
        getAvalRFC: (state: DataState, action: PayloadAction<string>) => { state.avalRFC = action.payload },
        getAvalCity: (state: DataState, action: PayloadAction<string>) => { state.avalCity = action.payload },
        getAvalFirstName: (state: DataState, action: PayloadAction<string>) => { state.avalFirstName = action.payload },
        getAvalSecondName: (state: DataState, action: PayloadAction<string>) => { state.avalSecondName = action.payload },
        getAvalFirstLastName: (state: DataState, action: PayloadAction<string>) => { state.avalFirstLastName = action.payload },
        getAvalSecondLastName: (state: DataState, action: PayloadAction<string>) => { state.avalSecondLastName = action.payload },
        getAvalContactMethod: (state: DataState, action: PayloadAction<string>) => { state.avalContactMethod = action.payload },
        getNIP: (state: DataState, action: PayloadAction<number>) => { state.NIP = action.payload },
        getAvalObjColonias: (state: DataState, action: PayloadAction<{ id: number, name: string }[]>) => { state.AvalObjColonias = action.payload },
        getAvalGender: (state: DataState, action: PayloadAction<string>) => {state.avalGender = action.payload},
        getAvalGenderType: (state: DataState, action: PayloadAction<number>) => {state.avalGenderType = action.payload},        //Revenue
        getRevenuePercentage: (state: DataState, action: PayloadAction<number | undefined>) => {
            if(action.payload === undefined){
                state.revenuePercentage = undefined;
            }
            else{
                if (action.payload > 100) { state.revenuePercentage = 100; }
                else { state.revenuePercentage = action.payload; }
            }
        },
        getRevenueConcentracionClientes: (state: DataState, action: PayloadAction<number | undefined>) => 
        { 
            if(action.payload === undefined){
                state.revenueCustomerConcentration = undefined;
            }else{
                if (action.payload > 100) { state.revenueCustomerConcentration = 100; }
                else state.revenueCustomerConcentration = action.payload;}
            },

        getRevenueFountain: (state: DataState, action: PayloadAction<number>) => { state.revenueFountain = action.payload },
        getRevenueSpin: (state: DataState, action: PayloadAction<number>) => { state.revenueSpin = action.payload },
        getRevenuePromedio: (state: DataState, action: PayloadAction<number>) => { state.revenueMonthlyAverage = action.payload },
        getRevenueGastoMensual: (state: DataState, action: PayloadAction<number>) => { state.revenueMonthlyExpense = action.payload },
        getRevenueFechaInicio: (state: DataState, action: PayloadAction<string>) => { state.revenueInitialDate = action.payload },
        getViewEkatena: (state: DataState) => { state.ViewEkatena = !state.ViewEkatena },
        //getViewManualForm: (state: DataState) => { state.ViewManualForm = !state.ViewManualForm },
        getAutorizeNIP: (state: DataState) => {state.autorizeNIP= true},

        //Validates
        getValidateUserRFC: (state: DataState, action: PayloadAction<boolean>) => { state.validateUserRFC = action.payload },
        getValidateUserEmail: (state: DataState, action: PayloadAction<boolean>) => { state.validateUserEmail = action.payload },
        getValidateLegalRepresentativeEmail: (state: DataState, action: PayloadAction<boolean>) => { state.validatelegalRepresentativeEmail = action.payload },
        getValidateLegalRepresentativeRFC: (state: DataState, action: PayloadAction<boolean>) => { state.validateLegalRepresentativeRFC = action.payload },
        getValidateAvalRFC: (state: DataState, action: PayloadAction<boolean>) => { state.validateAvalRFC = action.payload },
        getValidateAvalEmail: (state: DataState, action: PayloadAction<boolean>) => { state.validateAvalEmail = action.payload },
        getSuccessEkatena: (state: DataState, action: PayloadAction<boolean>) => { state.SuccessEkatena = action.payload },    
        //
        byEmail: (state: DataState, action: PayloadAction<boolean>) => { state.byEmail = action.payload },
        getActualStep: (state: DataState, action: PayloadAction<number>) => { state.actualStep = action.payload },
        getIsDisableQuoteForm: (state: DataState, action: PayloadAction<boolean>) => { state.isDisableQuoteForm = action.payload },
        getIsLoadingData: (state: DataState, action: PayloadAction<boolean>) => { state.isLoadingData = action.payload },
        setUnipadHash: (state: DataState, action: PayloadAction<string>) => {
            state.unipadHash = action.payload;
        },
        // Controla si el pago inicial tiene un error de límite ($350k).
        // Se despacha desde SliderEnganche cuando el monto capturado supera MAX_AMOUNT.
        getAssetDownPaymentHasError: (state: DataState, action: PayloadAction<boolean>) => { state.assetDownPaymentHasError = action.payload },
    },
});

export const {
    //Quote Type
    getQuoteType,

    //Data Arrendamiento
    getLeasingType,
    getUserActivo,
    getAssetPrice,
    getPurchaseOption,
    getAssetDownPayment,

    // Data Credit
    getProductType,
    getProductTypeOption,
    getCredit,
    getPlazo,
    getPayment,

    //Data General
    getEkatenaId,
    getUserPlazo,
    getTasa,
    getFolio,

    // Data Acreditado
    getUserType,
    getUserRFC,
    getUserFirstName,
    getUserSecondName,
    getUserFirstLastName,
    getUserSecondLastName,
    getUserCellphone,
    getUserEmail,
    getUserStreet,
    getUserNumberHouse,
    getUserCP,
    getUserCodigoPostalID,
    getUserState,
    getUserMunicipality,
    getUserColony,
    getUserContactMethod,
    getUserEnterprise,
    getUserNationality,
    getUserGender,
    // Data Legal Representative
    getLegalRepresentativeRFC,
    getLegalRepresentativeFirstName,
    getLegalRepresentativeSecondName,
    getLegalRepresentativeFirstLastName,
    getLegalRepresentativeSecondLastName,
    getLegalRepresentativeCellphone,
    getLegalRepresentativeEmail,
    getUserObjColonias,
    //Data Aval
    getAvalType,
    getAvalEnterprise,
    getAvalNationatily,
    getAvalCellphone,
    getAvalEmail,
    getAvalStreet,
    getAvalNumberHouse,
    getAvalCP,
    getAvalCodigoPostalID,
    getAvalState,
    getAvalMunicipality,
    getAvalColony,
    getAvalCity,
    getAvalContactMethod,
    getAvalFirstName,
    getAvalSecondName,
    getAvalFirstLastName,
    getAvalSecondLastName,
    getAvalGender,
    getAvalGenderType,
    getNIP,
    getAvalRFC,
    getAvalObjColonias,
    getViewEkatena,
    getRevenuePercentage,
    getRevenueFountain,
    getRevenueSpin,
    getRevenuePromedio,
    getRevenueGastoMensual,
    getRevenueFechaInicio,
    getRevenueConcentracionClientes,
    getValidateUserRFC,
    getValidateUserEmail,
    getValidateLegalRepresentativeEmail,
    getValidateLegalRepresentativeRFC,
    getValidateAvalRFC,
    getValidateAvalEmail,
    getAutorizeNIP,
    getSuccessEkatena,
    byEmail,
    getGenderType,
    getActualStep,
    getIsDisableQuoteForm,
    getCreditFormat,
    getIsLoadingData,
    setUnipadHash,
    getAssetDownPaymentHasError,
} = DataCotizador.actions;